import { ReactNode } from 'react';

import { Button } from '@gearbelt/ui/components';
import { useNavigate, useParams } from 'react-router';

import formSubmittedVector from '@/assets/vectors/form-submitted.svg';
import HomeIcon from '@/components/icons/home';
import { Sheet, SheetContent } from '@/components/ui/sheet';

interface AWAFormSubmissionDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  recordLabel: string;
  recordIcon: ReactNode;
}

export function AWAFormSubmissionDrawer({ open, onOpenChange, title, description, recordLabel, recordIcon }: AWAFormSubmissionDrawerProps) {
  const { workspaceId } = useParams();
  const navigate = useNavigate();

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        hideCloseIcon
        className="mx-auto h-full w-full p-0 focus:outline-none sm:max-w-[800px]"
        onInteractOutside={(e) => e.preventDefault()}>
        <div className="flex h-full w-full flex-col">
          <div className="bg-grey-1 flex flex-1 flex-col items-center justify-center gap-4 px-6">
            <img src={formSubmittedVector} alt={title} className="w-40" />

            <div className="flex max-w-[304px] flex-col items-center gap-2">
              <h2 className="text-lg font-medium">{title}</h2>

              <p className="text-secondary-text text-center text-sm">{description}</p>
            </div>

            <div className="flex gap-3">
              <Button
                icon={<HomeIcon size={20} />}
                variant="default"
                onClick={() => {
                  onOpenChange(false);
                  navigate(`/${workspaceId}/maintenance`);
                }}>
                Home
              </Button>
              <Button icon={recordIcon} variant="outline" onClick={() => onOpenChange(false)}>
                {recordLabel}
              </Button>
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
